import React, {useCallback, useMemo} from 'react';
import {useEventConnections} from '../../../../../../../data/hooks/connections/useEventConnections';
import styles from '../../BubblesFilter.module.scss';
import FilterButton from '../../FilterButton';

const InnerCircleSubFilter = props => {
    const {className = '', event, filterParams, type: innerCircleType, icon, activeFilter, onFilterActivation} = props,
        allConnections = useEventConnections(event.id),
        connections = useMemo(() => allConnections.filter(connection => connection.connection[innerCircleType]), [allConnections, innerCircleType]),
        isActive = filterParams?.connections?.[innerCircleType];

    const handleClick = useCallback(
        () =>
            app.store.dispatch(
                app.actions.participants.setFilterParams(event.id, {
                    ...(filterParams || {}),
                    connections: {
                        [innerCircleType]: !filterParams?.connections?.[innerCircleType],
                    },
                })
            ),
        [filterParams]
    );

    if (!connections.length) return null;

    return (
        <FilterButton className={styles.innerCircle} event={event} active={isActive} onClick={handleClick} icon={icon}>
            {connections.length}
        </FilterButton>
    );
};

export default InnerCircleSubFilter;
